import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

export const transferWrapper = (Component: FC<any>) => (props: any) => {
  return (
    <div className='transfer-wrapper'>
      <div className='TabLinks'>
        <NavLink to={Routes.transferList.path}>
          <Icon.User />
          Transfer List
        </NavLink>

        <NavLink
          to={Routes.TransferToUser.path}

          // isActive={() => props?.location?.pathname === '/transfer/to-user'}
        >
          <Icon.KYC />
          Transfer To User
        </NavLink>
      </div>

      <Component {...props} />
    </div>
  );
};
